import * as React from "react";
import {Box, Typography, Button, DialogTitle, Dialog, MenuItem} from "@mui/material";
import { styled } from "@mui/material/styles";
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import InputLabel from '@mui/material/InputLabel';

type Props = {
    selected: any;
    open: any;
    handleClose: any;
    handleMove: any;
    coders: any;
    allSelected: boolean;
};

const StyledDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    }
}));

const StyledButton = styled(Button)({
    borderRadius: "4px",
    textTransform: "none",
    flexGrow: 1,
    maxWidth: '100px',
    maxHeight: '40px',
    minWidth: '100px',
    minHeight: '40px'
});

export const ReassignCases = ({
    selected,
    open,
    handleClose,
    handleMove,
    coders,
    allSelected,
    ...props
}: Props) => {

    const [assignee, setAssignee] = React.useState(null);
    const handleChangeAssignee= (event: SelectChangeEvent) => {
        setAssignee(event.target.value as string);
    };

    const availableCoders = coders.map(coder => (
        <MenuItem key={coder?.data?.worker_id} value={coder?.data?.worker_id}>{coder?.data.last_name + ", " + coder?.data.first_name}</MenuItem>
    ));

    return (
        <StyledDialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
            <DialogTitle sx={{ m: 0, p: 2 }} id="reassign-title">
                Reassign cases
            </DialogTitle>
            <IconButton
                aria-label="close"
                onClick={handleClose}
                sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: (theme) => theme.palette.grey[500],
                }}
            >
                <CloseIcon />
            </IconButton>
            <DialogContent>
                <Typography gutterBottom sx={{mb: 2}}>
                    {selected ? selected.length : 0} cases selected
                </Typography>
                <Box sx={{ minWidth: 120 }}>
                <FormControl fullWidth>
                    <InputLabel id="select-label-assignee">Please select assignee</InputLabel>
                <Select
                    id="select-assignee"
                    value={assignee}
                    label={"Please select assignee"}
                    onChange={handleChangeAssignee}>
                    {availableCoders}
                </Select>
                </FormControl>
                </Box>
            </DialogContent>
                <DialogActions>
                    <StyledButton variant="outlined" onClick={() => handleClose()}>
                        Cancel
                    </StyledButton>
                    <StyledButton variant="contained" disabled={!assignee} sx={{ml: 5}} onClick={() => handleMove(selected, assignee,true)}>
                        Move
                    </StyledButton>
                </DialogActions>
        </StyledDialog>
    )
}
